import React from "react";
import { useProductionStore } from "../../../stores/production";
import { formatComptableMaisPasTrop } from "../../../services/function";

const BillingByMonth = () => {
  const { production2 } = useProductionStore();

  // Récupere tous les totaux uniques
  const months: string[] = production2?.data
    ?.map((row: any) => row.allMonths.map((month: any) => month.month))
    .flat(2);

  const uniqueMonths = [...new Set(months)];

  return (
    <table className="min-w-full font-Nunito bg-white shadow-lg border border-gray-100 rounded-2xl h-auto mt-5 overflow-x-scroll overflow-y-scroll">
      <tr className="h-12">
        <th className="border border-gray-300 px-4 py-2 bg-thead text-left w-44">
          Clients
        </th>
        {uniqueMonths?.map((month, index) => (
          <th
            key={index}
            className="border border-gray-300 px-4 py-2 bg-thead text-left w-10"
          >
            {month}
          </th>
        ))}
        <th className="border border-gray-300 px-4 py-2 bg-thead text-left w-44">
          Cumules
        </th>
      </tr>
      {production2?.data?.map((row: any, index: number) => (
        <React.Fragment key={index}>
          <tbody>
            <tr>
              <td className="border border-gray-300 px-4 py-2 text-left w-44">
                {row.name}
              </td>
              {uniqueMonths?.map((_, index) => (
                <td
                  key={index}
                  className="border border-gray-300 px-4 py-2 text-left w-10"
                >
                  {formatComptableMaisPasTrop(
                    row.allMonths[index]?.totalAmount
                  )}
                </td>
              ))}
              <td className="border border-gray-300 px-4 py-2 text-left w-44">
                {formatComptableMaisPasTrop(row.totalAmount)}
              </td>
            </tr>
          </tbody>
        </React.Fragment>
      ))}
      <tfoot className="w-full ">
        <tr className="border-gray-300 bg-gray-200 h-8 w-full">
          <th className="border border-gray-300 px-4 py-2  text-left w-44">
            Totaux
          </th>
          {uniqueMonths?.map((_, index) => (
            <th
              key={index}
              className="border border-gray-300 px-4 py-2  text-left w-10"
            >
              {formatComptableMaisPasTrop(
                production2.totalByMonth?.[index]?.amount
              )}
            </th>
          ))}
          <th className="border border-gray-300 px-4 py-2  text-left w-44">
            {formatComptableMaisPasTrop(production2?.totalOfTotal)}
          </th>
        </tr>
      </tfoot>
    </table>
  );
};

export default BillingByMonth;
